
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/auth/AuthContext';
import { Card } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import MentorsList from '@/components/admin/mentors/MentorsList';
import OfficeHoursList from '@/components/admin/office-hours/OfficeHoursList';

const MentorManagement = () => {
  const { isAdmin } = useAuth();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('mentors');
  
  useEffect(() => {
    if (!isAdmin()) {
      navigate('/dashboard');
    }
  }, [isAdmin, navigate]);
  
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold section-header">Mentor Management</h1>
        <p className="text-muted-foreground section-subheader">Manage mentors and office hours scheduling</p>
      </div>
      
      <Tabs defaultValue="mentors" value={activeTab} onValueChange={setActiveTab}>
        <TabsList className="grid w-full grid-cols-2">
          <TabsTrigger value="mentors">Mentors</TabsTrigger>
          <TabsTrigger value="office-hours">Office Hours</TabsTrigger>
        </TabsList>
        
        <TabsContent value="mentors" className="mt-4">
          <MentorsList />
        </TabsContent>
        
        <TabsContent value="office-hours" className="mt-4">
          <OfficeHoursList />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default MentorManagement;
